import React, { useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLeftBar } from "../../context/LeftBar";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import NavItem from "./MenuItem/NavItem";
import utils from "../../QlikUtils";
import { Button } from "@mui/material";
import { useTour } from "@reactour/tour";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("10/05/2023");
  const [fabricanteNome, setFabricanteNome] = useState("CLIENTE");
  const screenBreakpoint = 500;

  const { t, i18n } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { setIsOpen, setCurrentStep } = useTour();

  const changeLanguage = async (tempApp, language) => {
    localStorage.setItem("language", language);
    i18n.changeLanguage(language);
    await tempApp
      .field(config.app.langVar)
      .selectMatch(utils.languageHandleQVF(language));
  };

  const initialSelecao = () => {
    app.variable.getContent("vDescFabricanteNomeUpper", (reply) => {
      const data = reply.qContent.qString;
      setFabricanteNome(data);
    });
    /*  app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data);
    }); */
  };

  useLayoutEffect(() => {
    let language = params.get("lang");
    if (!language) {
      language = localStorage.getItem("language");
    }
    language = utils.guardLanguage(language);
    changeLanguage(app, language);
  }, []);

  const startTutorial = () => {
    setCurrentStep(0);
    setIsOpen(true);
  };

  useEffect(() => {
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  useEffect(() => {
    if (app) {
      initialSelecao();
    }
  }, [app]);

  const openedTutorial = localStorage.getItem("openedTutorial");
  
  useEffect(() => {
    if (!openedTutorial) {
      startTutorial();
    }
  }, [openedTutorial]);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="leftSideHeader">
        <div className={leftBarOpened ? "logo" : "logo is-hidden"}>
          <img
            style={{ width: "200px", height: "60px" }}
            src={logo}
            alt="logo"
          />
        </div>
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          <i
            className={
              leftBarOpened
                ? "fal fa-arrow-left close-desktop"
                : "fal fa-arrow-right"
            }
          />
          <i className={leftBarOpened ? "fal fa-times close-mobile" : ""} />
        </button>
      </div>
      <div>&nbsp;</div>

      {leftBarOpened && (
        <>
          <div className="info-client">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                paddingLeft: "10px",
                justifyContent: "start",
              }}
            >
              <span style={{ color: "#909FA7" }}>Cliente: </span>
              <h2 style={{ color: "#fff", marginTop: "4px" }}>
                {fabricanteNome}
              </h2>
            </div>
          </div>
          <div style={{ boxShadow: "inset 0 -1px 0 #184952", width: "100%" }}>
            &nbsp;
          </div>
        </>
      )}

      <div className="leftSideContent">
        <ul>
          <NavItem icon="fas fa-chart-pie" name="Matriz" path="/matriz" />
        </ul>
        <ul>
          <NavItem icon="fas fa-chart-bar" name="Simulador" path="/simulador" />
        </ul>
        <ul>
          <NavItem
            icon="fas fa-chart-line"
            name="Evolution"
            path="/evolution"
          />
        </ul>
      </div>
      <div></div>
      {leftBarOpened && (
        <div
          style={{
            display: "flex",
            flexDirection: "column-reverse",
            width: "100%",
            height: "100%",
            paddingLeft: "10px",
            color: "#ccc",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginBottom: "20px",
          }}
        >
          <h4>Atualizado em: {dataAtualizacao} </h4>
          <Button
            className="tutorialItem"
            startIcon={<HelpOutlineIcon />}
            onClick={() => startTutorial()}
            sx={{
              color: "#fff",
              textTransform: "none",
            }}
          >
            Tutorial
          </Button>
        </div>
      )}
    </div>
  );
}

LeftSideMenu.defaultProps = {
  logo: "",
};

LeftSideMenu.propTypes = {
  logo: PropTypes.string,
};

export default LeftSideMenu;
